import 'css-chunksrc/client/scenes/accessRestrictionsEdition/styles.scss';export default {
  "accessRestrictionsEdition": "_accessRestrictionsEdition_2smxq_1",
  "area": "_area_2smxq_5",
  "name": "_name_2smxq_12",
  "roleSelection": "_roleSelection_2smxq_18",
  "col": "_col_2smxq_22"
};